export default "__VITE_ASSET__DJi4TVBS__"